import { transform } from 'lodash-es'

import { clickParamsMapping } from './constants.js.erb'

export const mapConfig = (params) => {
  return transform(params, (acc, val, key) => {
    acc[clickParamsMapping[key]] = val + ''
  })
}
